import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHTMLTags'
})
export class StripHTMLTagsPipe implements PipeTransform {

  transform(value: any, args?: any): any 
  {
    if(value == null)
    	return value;
	var regex = /(&nbsp;|<([^>]+)>)/ig;
	return value.replace(regex, '');
  }

}
